// Declare the allowed text list directly in the module
const allowedText = [
  "+91 960 142 1472",
  "+1 210 767 3194",
  "+44 (0)207 947 4950",
  "+61 2 9844 5446",
  "+61 3 9581 2659",
  "+1 647 978 7562",
  "+1 (765) 409-9497",
  "+1 765 409 9497",
  "career@tatvasoft.com",
  "info@tatvasoft.com",
  "info@tatvasoft.co.uk",
  "info@tatvasoft.com.au",
  "legal@tatvasoft.com",
  "+1 503 832 4034"
];

export function initContextMenu() {
  // Only initialize if the body does NOT have the 'tatva-landing-pages' class
  if (!document.body.classList.contains('tatva-landing-pages')) {
    
    // 1. Listen for Cut, Copy, and Paste
    document.body.addEventListener("cut", handleCopyCutPaste);
    document.body.addEventListener("copy", handleCopyCutPaste);
    document.body.addEventListener("paste", handleCopyCutPaste);

    // 2. Listen for Right-Click Context Menu
    document.body.addEventListener("contextmenu", handleContextMenu);

    // 3. Listen for Keyboard Shortcuts (F12, Ctrl+U, etc.)
    document.addEventListener("keydown", handleKeyDown);
  }
}

// Handler for Cut, Copy, and Paste
function handleCopyCutPaste(e) {
  // Allow cut, copy, paste for elements inside office list container and contact info block
  if (
    e.target.closest('.contact-offices-list') || 
    e.target.closest('.offices') || 
    e.target.closest('.contact-info-outer')
  ) {
    return true;
  }

  let currentTarget = e.target;
  while (currentTarget && currentTarget.parentElement !== document.body) {
    currentTarget = currentTarget.parentElement;
  }
  if (!currentTarget) return;

  if (document.querySelectorAll('.contact-us-wrapper').length === 1 && currentTarget.classList.contains("main-site-wrapper")) {
    if (
      allowedText.includes(e.target.textContent.trim()) || 
      (e.target.parentElement && e.target.parentElement.classList.contains("content-wrapper")) || 
      e.target.localName === "address"
    ) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  } else {
    if (
      e.target.parentElement && 
      !e.target.parentElement.classList.contains("add-box-inner") && 
      e.target.parentElement.localName !== "address"
    ) {
      if (!allowedText.includes(e.target.textContent.trim())) {
        e.preventDefault();
        return false;
      }
    }
  }
}

// Handler for Right-Click Context Menu
function handleContextMenu(e) {
  // Expose context menu for elements inside office list container and contact info block
  if (
    e.target.closest('.contact-offices-list') || 
    e.target.closest('.offices') || 
    e.target.closest('.contact-info-outer')
  ) {
    return true; 
  }

  let currentTarget = e.target;
  while (currentTarget && currentTarget.parentElement !== document.body) {
    currentTarget = currentTarget.parentElement;
  }
  if (!currentTarget) return;

  if (document.querySelectorAll('.contact-us-wrapper').length === 1 && currentTarget.classList.contains("main-site-wrapper")) {
    if (
      allowedText.includes(e.target.textContent.trim()) || 
      (e.target.parentElement && e.target.parentElement.classList.contains("content-wrapper")) || 
      e.target.localName === "address"
    ) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  } else {
    if (
      e.target.parentElement && 
      !e.target.parentElement.classList.contains("add-box-inner") && 
      e.target.parentElement.localName !== "address"
    ) {
      if (!allowedText.includes(e.target.textContent.trim())) {
        e.preventDefault();
        return false;
      }
    }
  }

  // Allow native behavior on mobile devices
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
}

// Handler for Keyboard Shortcuts (F12, DevTools, View Source)
function handleKeyDown(e) {
  const pressedKey = String.fromCharCode(e.keyCode).toLowerCase();

  // Prevent F12 (opens Developer Tools)
  if (e.keyCode === 123) {
    e.preventDefault();
    return false;
  }

  // Prevent Ctrl + Shift + I (opens Inspector)
  if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
    e.preventDefault();
    return false;
  }

  // Prevent Ctrl + U (opens View Source)
  if (e.ctrlKey && pressedKey === "u") {
    e.preventDefault();
    return false;
  }
}
